import React from "react";
import styled, { css } from "styled-components";

const Button = ({
  text,
  primary,
  secondary,
  tertiary,
  warning,
  loading,
  className,
  disabled,
  onClick = () => { },
  type = undefined,
  ...rest
}) => {
  const isDisabled = loading || disabled;

  return (
    <Container className={className}>
      <ButtonWrapper>
        <ButtonStyled
          className="button"
          primary={primary}
          secondary={secondary}
          tertiary={tertiary}
          warning={warning}
          loading={loading}
          type={type}
          disabled={isDisabled}
          onClick={(e) => (isDisabled ? null : onClick(e))}
          {...rest}
        >
          {text}
        </ButtonStyled>
        {loading && <Spinner src="loading.gif" />}
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div``;

const ButtonWrapper = styled.div`
  position: relative;
`;

const ButtonStyled = styled.div`
  cursor: pointer;
  box-sizing: border-box;
  text-align: center;
  border-radius: 10px;
  padding: 15px 15px;
  font-weight: 600;
  width: 100%;
  font-size: 0.9em;
  display: block;

  user-select: none;

  ${(props) => {
    if (props.type !== undefined) {
      switch (props.type) {
        case "quartary":
          return css`
            background-color: #1450db;
            color: white;
          `;
          break;
      }
    }

    if (props.primary)
      return css`
        background-color: rgb(50, 176, 234);
        color: white;
      `;
    else if (props.secondary)
      return css`
        color: rgb(50, 176, 234);
      `;
    else if (props.tertiary)
      return css`
        background-color: #2196f3;
        color: white;
      `;
    else if (props.warning)
      return css`
        background-color: #e53935;
        color: white;
      `;
  }}

  ${(props) =>
    (props.loading || props.disabled) &&
    css`
      cursor: not-allowed;
      opacity: 0.2;
    `}
`;

const Spinner = styled.img`
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;

  margin: auto;
  width: 15px;
  height: 15px;
  cursor: not-allowed;
`;

export default Button;
